import config from '../../config/index';
export const OrderElementSelector = {
  smsCodeRow: '#trValidateCode',
  smsCode: '#SMSCode1',
  sendCode: '#btnSendCode1',
  imgValidCodeRow: '#divimgValidCodeDealer',
  imgValidCode: '#imgValidCodeDealer',
  saveOrder: '#btnSaveOrder',
  imgValidCodeLayerOfSMS: '#liimgValidCodeSMS',
  imgValidCodeOfSMS: '#imgValidCodeSMS',
  imgValidCodeOfSMSError: '#yzmerror',
  imgCodeOfSMS: '#SMSCode2',
  confirmImgCode: '#btnSendCodeok',
  refreshImgCode: '#imgValidCodeSMSchangeCode',
};
export const OrderUrls = {
  GetCodeCreate: config.dealermUrl + '/vrhandler/GetCodeCreate',
  GetCodeImage: config.dealermUrl + '/vrhandler/GetCodeImage',
  VerificationCode: config.dealermUrl+'/vrhandler/Order/VerificationCode2',
  NeedVerificationImgCode: config.dealermUrl+ '/vrhandler/Order/IsNeedVerificationImgCode',
  PostCode: config.dealermUrl+ '/vrhandler/Order/PostCode',
  PostCodeCreate: config.dealermUrl+ '/vrhandler/Order/PostCodeCreate',
  GetImgCode: config.dealermUrl+ '/vrhandler/Order/GetImgCode',
};

export const defaultCallbackConfig = {
  block: false,
  callback_success: function () {
    console.log('callback_success');
  },
  callback: function () {
    console.log('callback');
  },
};
